<template>
  <div class="div1">
    <mu-appbar style="width: 100%;height:40px;" color="blue" v-show="!openSearchDialog">
      <mu-button icon slot="left" @click="toHome"  style="font-size: 12px;width:40px;margin: 0;">
        <mu-icon value="home"></mu-icon>
      </mu-button>
      <span style="font-size: 14px;"><mu-chip class="demo-chip" color="blue200" delete @delete="logout" style="height:22px; vertical-align:middle;">
          <mu-icon value="person"/><span style="font-size: 10px;">{{username}}</span>
        </mu-chip></span>
      <span style="font-size: 14px;">库存查询</span>

      <mu-button flat slot="right"  small  style="font-size: 12px;width:40px;margin: 0;" @click="search_click"><mu-icon value="search" ></mu-icon></mu-button>

    </mu-appbar>

    <mu-paper :z-depth="5" style="width: 100%;min-height:40px;margin: 0;padding: 10px;background-color: rgba(222, 222, 222, .5)" v-show="!openSearchDialog">
      <span slot="right" style="font-size: 10px;"><span style="font-size: 9px;">当前 / 总数 ：</span>
        <span style="width: 10px;color: blue;font-size: 12px;" slot="right">{{search_total_count}} / {{total_count}}</span>

         <template v-if="searchMap.order_direction != ''">
            <mu-chip class="demo-chip" color="blue200"  style="height:22px; vertical-align:middle;">
              <mu-avatar text-color="blue300" color="indigo900" :size="28"><span style="font-size: 9px;">排序</span></mu-avatar>
              <span style="font-size: 10px;">
                <template v-if="searchMap.order_direction == 'desc'">
                  ↓
                </template>
                 <template v-if="searchMap.order_direction == 'asc'">
                  ↑
                </template>

                <template v-if="searchMap.order_by == 'order_in_out_sub_quantity_sum'">
                  库存数
                </template>
                <template v-else>
                  品种
                </template>
              </span>
            </mu-chip>
        </template>

         <template v-if="searchMap.in_stock_type != ''">
            <mu-chip class="demo-chip" color="blue200"  delete @delete="serach_key_delete('in_stock_type')" style="height:22px; vertical-align:middle;">
              <mu-avatar text-color="blue300" color="indigo900" :size="28"><span style="font-size: 9px;">品种</span></mu-avatar> <span style="font-size: 10px;">{{searchMap.in_stock_type}}</span>
            </mu-chip>
        </template>
         <template v-if="searchMap.in_stock_model != ''">
            <mu-chip class="demo-chip" color="blue200"  delete @delete="serach_key_delete('in_stock_model')" style="height:22px; vertical-align:middle;">
              <mu-avatar text-color="blue300" color="indigo900" :size="28"><span style="font-size: 9px;">规格</span></mu-avatar> <span style="font-size: 10px;">{{searchMap.in_stock_model}}</span>
            </mu-chip>
        </template>

         <template v-if="searchMap.in_stock_from != ''">
            <mu-chip class="demo-chip" color="blue200"  delete @delete="serach_key_delete('in_stock_from')" style="height:22px; vertical-align:middle;">
              <mu-avatar text-color="blue300" color="indigo900" :size="28"><span style="font-size: 9px;">来源</span></mu-avatar> <span style="font-size: 10px;">{{searchMap.in_stock_from}}</span>
            </mu-chip>
        </template>

         <template v-if="searchMap.show0_switch">
            <mu-chip class="demo-chip" color="blue200"  delete @delete="serach_key_delete('show0_switch')" style="height:22px; vertical-align:middle;">
              <span style="font-size: 10px;">显示所有</span>
            </mu-chip>
        </template>

      </span>

    </mu-paper>


    <mu-load-more ref="lm" @refresh="refresh" :refreshing="refreshing" :loading="loading" @load="load" style="width: 100%" v-show="!openSearchDialog" class="demo-loadmore-content">
        <mu-list style="width:100%;padding:0;margin:0;border: 0px solid #000;background-color: rgba(222, 222, 222, .5)">
          <template v-for="(item,index) in in_list">

            <mu-paper class="demo-paper" :z-depth="0" style="width:100%;padding:0;margin: 0;border: 0px solid #000;">
              <mu-expansion-panel :z-depth="0" style="width:100%;border: 0px solid #000;margin:0 auto 6px;">
                <div slot="header" style="border: 0px solid #000;width:95%;padding: 5px 0;">

                <div style="display:flex;justify-content:space-between;align-items:center;border: 0px solid #000;">
                  <div style="border: 0px solid #0f0;">
                    <span class="s_key">{{index + 1}}.</span>
                    <span style="font-size : 16px;font-weight: bolder;">{{item.in_stock_type}}</span>
                    &nbsp;&nbsp; <span style="font-size : 16px;font-weight: bolder;">{{item.in_stock_model}}</span><span class="s_key">ML</span>
                  </div>
                  <div style="display:flex;flex-direction:column; justify-content:center; align-items: flex-end; border: 0px solid #0f0;margin: 0;padding: 5px;">
                    <div style="border: 0px solid #f00;"><span class="s_key">库存:</span><span class="s1">{{item.in_out_sub_quantity_sum}}</span></div>
                  </div>
                </div>

              </div>

                <template v-if="item.map_from">
                  <table class="table1">
                    <thead>
                      <tr>
                        <th rowspan="2">来源</th>
                        <th rowspan="2">年份</th>
                        <th colspan="5">入库</th>

                        <th colspan="5">出库</th>

                      </tr>
                      <tr>
                        <th>时间</th>
                        <th>数量</th>
                        <th>单价</th>
                        <th>总价</th>
                        <th>库存</th>

                        <th>平台</th>
                        <th>时间</th>
                        <th>数量</th>
                        <th>单价</th>
                        <th>总价</th>
                      </tr>
                    </thead>
                    <template v-for="(list_in ,from_key,from_index) in item.map_from">
                      <template v-for="(in_item,in_item_index) in list_in.list_in">
                        <template v-if="in_item.list_child_ofin">
                          <template v-for="(out_item,out_item_index) in in_item.list_child_ofin">
                            <tr>
                              <td  v-if="in_item_index ==0 && out_item_index==0" :rowspan="list_in.list_in_rowspan">{{from_key}}</td>
                              <td  v-if="out_item_index==0" style="text-align: center" :rowspan="in_item.list_child_ofin.length">{{in_item.in_stock_production_date}}</td>
                              <td class="intd" style="text-align: center" v-if="out_item_index==0" :rowspan="in_item.list_child_ofin.length">{{in_item.in_stock_date_f.replace(STORE.cuur_year,"")}}</td>
                              <td class="intd" v-if="out_item_index==0" :rowspan="in_item.list_child_ofin.length" style="text-align: right">{{in_item.in_stock_quantity}}</td>
                              <td class="intd" v-if="out_item_index==0" :rowspan="in_item.list_child_ofin.length" style="text-align: right">¥{{in_item.in_stock_unit_price}}</td>
                              <td class="intd" v-if="out_item_index==0" :rowspan="in_item.list_child_ofin.length" style="text-align: right">¥{{in_item.in_stock_total_price}}</td>
                              <td class="intd" v-if="out_item_index==0" :rowspan="in_item.list_child_ofin.length" style="text-align: right;color: #f00;">{{in_item.in_out_sub_quantity_sum}}</td>

                              <td class="outtd">{{out_item.out_stock_platform}}</td>
                              <td class="outtd" style="text-align: center">{{out_item.out_stock_date_f.replace(STORE.cuur_year,"")}}</td>
                              <td class="outtd" style="text-align: right">{{out_item.out_stock_quantity}}</td>
                              <td class="outtd" style="text-align: right">¥{{out_item.out_stock_unit_price}}</td>
                              <td class="outtd" style="text-align: right">¥{{out_item.out_stock_total_price}}</td>
                            </tr>
                          </template>
                        </template>
                        <template v-else>
                          <tr>
                            <td  v-if="in_item_index ==0" :rowspan="list_in.list_in_rowspan">{{from_key}}</td>
                            <td style="text-align: center">{{in_item.in_stock_production_date}}</td>
                            <td class="intd" style="text-align: center">{{in_item.in_stock_date_f.replace(STORE.cuur_year,"")}}</td>
                            <td class="intd" style="text-align: right">{{in_item.in_stock_quantity}}</td>
                            <td class="intd" style="text-align: right">¥{{in_item.in_stock_unit_price}}</td>
                            <td class="intd" style="text-align: right">¥{{in_item.in_stock_total_price}}</td>
                            <td class="intd" style="text-align: right;color: #f00;">{{in_item.in_out_sub_quantity_sum}}</td>

                            <td class="outtd"></td>
                            <td class="outtd"></td>
                            <td class="outtd" style="text-align: right"></td>
                            <td class="outtd" style="text-align: right"></td>
                            <td class="outtd" style="text-align: right"></td>
                          </tr>
                        </template>
                      </template>
                      <tr><td  colspan="12" style="height: 2px;background-color: #ddd;padding: 0;"></td></tr>
                    </template>
                  </table>
                </template>
              </mu-expansion-panel>
            </mu-paper>

            <template v-if="index == search_total_count - 1">
              <mu-paper class="demo-paper" :z-depth="0" style="border: 0px solid #0f0; width:100%;padding: 0;margin:0;">
                <mu-container style="border: 0px solid #f00;vertical-align: center;text-align: center;">
                  <mu-row gutter>
                    <mu-col span="12">
                      <span style="font-size: 8px;font-weight:bold; color: rgba(125,125,150,.8)" >------------ 已 经 到 底 -------------</span>
                    </mu-col>
                  </mu-row>
                </mu-container>
              </mu-paper>
            </template>

          </template>
        </mu-list>
      </mu-load-more>

    <mu-container width="100%" v-show="openSearchDialog" height="100%">
      <mu-appbar  title="库存查询">
        <mu-button slot="left" icon @click="openSearchDialog = false">
          <mu-icon value="close"></mu-icon>
        </mu-button>
        <mu-button slot="right" flat  @click="openSearchDialog = false">
          取消
        </mu-button>
      </mu-appbar>
      <div style="padding: 24px;">
        <mu-form ref="new_searchMap" :model="form" class="mu-demo-form" label-position="left" label-width="100">
          <mu-form-item prop="in_stock_type" label="品种">
            <mu-auto-complete :data="STORE.in_stock_type_all" :max-search-results="10" v-model="new_searchMap.in_stock_type"
                              open-on-focus></mu-auto-complete>
          </mu-form-item>
          <mu-form-item prop="in_stock_model" label="规格">
            <mu-text-field v-model="new_searchMap.in_stock_model"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="in_stock_from" label="来源">
            <mu-text-field v-model="new_searchMap.in_stock_from"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="show0_switch" label="排序">
            <mu-radio v-model="new_searchMap.order_direction" value="desc" label="↓"></mu-radio>
            <mu-radio v-model="new_searchMap.order_direction" value="asc" label="↑"></mu-radio>
          </mu-form-item>
          <mu-form-item prop="show0_switch">
            <mu-radio v-model="new_searchMap.order_by" value="order_in_out_sub_quantity_sum" label="库存数"></mu-radio>
            <mu-radio v-model="new_searchMap.order_by" value="order_in_stock_type_in_stock_model" label="品种"></mu-radio>
          </mu-form-item>
          <mu-form-item prop="show0_switch" label="显示所有">
            <mu-switch v-model="new_searchMap.show0_switch"></mu-switch>
          </mu-form-item>
        </mu-form>

        <mu-button color="primary" full-width @click="submit_search">搜索</mu-button>

      </div>
    </mu-container>
  </div>

</template>

<script>
  import axios from 'axios'
  import Qs from 'qs'
  import Toast from 'muse-ui-toast';
  import { Dialog } from 'vant';
  export default {
    created:function(){
      //默认查询近一年
      let _this = this;
      let loading = _this.$loading();
      let parms = {};
      Object.assign( parms , this.searchMap ,{begin:0});
      console.log("select.mvc parms = "+JSON.stringify(parms));
      axios.post('/stock/stock/group_select.mvc',Qs.stringify(parms))
        .then(function (response) {
          loading.close();
          //console.log("select.mvc response = "+JSON.stringify(response));
          if(response.data.status == "0"){
            Toast.error('没有数据！');
          }
          if(response.data.status == "2"){
            Toast.error('查询异常！');
          }
          if (response.data.status == "3") {
            Dialog.alert({
              title: '请重新登录',
              message: ''
            }).then(() => {
              _this.$router.replace("/Login");
            });
          }
          if(response.data.status == "1"){
            _this.in_list = response.data.data;
            _this.total_count = response.data.total_count;
            _this.search_total_count = response.data.search_total_count;
            _this.$refs.lm.loadedAll = _this.search_total_count > _this.in_list.length;
            Toast.success('OK！');
          }
        })
        .catch(function (error) {
          loading.close();
          console.log(error);
        });


    },
    data () {
      return {
        username : this.STORE.login.name,
        in_list : {},
        search_total_count : 0,
        total_count : 0,
        refreshing: false,
        loading: false,
        text: 'List',
        //loaded-all : false,
        openSearchDialog: false,

        openUpdateDialog: false,
        searchMap: {
          in_stock_type: '',
          in_stock_model:'',
          in_stock_from:'',
          show0_switch:false,
          order_direction:'desc',
          order_by:'order_in_out_sub_quantity_sum'
        },
        new_searchMap: {
          in_stock_type: '',
          in_stock_model:'',
          in_stock_from:'',
          show0_switch:false,
          order_direction:'desc',
          order_by:'order_in_out_sub_quantity_sum'
        }
      }
    },
    methods: {
      toHome() {
        this.$router.replace("/Home");
      },
      logout() {
        let _this = this;
        let loading = _this.$loading();

        axios.post('/stock/logout.mvc', Qs.stringify({
          name: _this.STORE.login.name
        }))
          .then(function (response) {
            loading.close();
            console.log(response);
            if(response.data == "1"){
              _this.STORE.login.name = "";
              _this.$router.replace("/Login");
            }
          })
          .catch(function (error) {
            _this.STORE.login.name = "";
            loading.close();
            console.log(error);
          })
      },
      search_click () {
        Object.assign(this.new_searchMap, this.searchMap);
        //this.new_searchMap = this.searchMap;
        this.openSearchDialog = true;
      },
      serach_key_delete(t) {
        if (t == 'in_stock_type'){
          this.searchMap.in_stock_type = "";
          this.new_searchMap.in_stock_type = "";
        }
        if (t == 'in_stock_model'){
          this.searchMap.in_stock_model = "";
          this.new_searchMap.in_stock_model = "";
        }
        if (t == 'in_stock_from'){
          this.searchMap.in_stock_from = "";
          this.new_searchMap.in_stock_from = "";
        }
        if (t == 'show0_switch'){
          this.searchMap.show0_switch = false;
          this.new_searchMap.show0_switch = false;
        }
        this.submit_search();
      },
      update(index){
        let item = this.in_list[index];
        this.form_update = item;
        this.form_update.in_stock_date = item.in_stock_date_f;
        this.form_update.in_stock_id = item.in_stock_id ;
        this.openUpdateDialog = true;
      },
      refresh () {
        this.refreshing = true;
        let parms = {};
        let _this = this;
        Object.assign( parms , this.searchMap ,{begin:0});
        axios.post('/stock/stock/group_select.mvc',Qs.stringify(parms))
          .then(function (response) {
            _this.refreshing = false;
            if(response.data.status == "0"){
              Toast.error('没有数据！');
            }
            if(response.data.status == "2"){
              Toast.error('查询异常！');
            }
            if (response.data.status == "3") {
              Dialog.alert({
                title: '请重新登录',
                message: ''
              }).then(() => {
                _this.$router.replace("/Login");
              });
            }
            if(response.data.status == "1"){
              _this.in_list = response.data.data;
              _this.total_count = response.data.total_count;
              _this.search_total_count = response.data.search_total_count;
              _this.$refs.lm.loadedAll = _this.search_total_count > _this.in_list.length;
              Toast.success('刷新完成！');
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      load () {
        let _this = this;
        _this.$refs.lm.loadedAll = _this.search_total_count > _this.in_list.length;
        if(_this.$refs.lm.loadedAll){
          this.loading = true;
          let parms = {};
          Object.assign( parms , this.searchMap ,{begin:_this.in_list.length});
          axios.post('/stock/stock/group_select.mvc',Qs.stringify(parms))
            .then(function (response) {
              _this.loading = false;
              _this.refreshing = false;
              if(response.data.status == "0"){
                Toast.error('没有数据！');
              }
              if(response.data.status == "2"){
                Toast.error('查询异常！');
              }
              if (response.data.status == "3") {
                Dialog.alert({
                  title: '请重新登录',
                  message: ''
                }).then(() => {
                  _this.$router.replace("/Login");
                });
              }
              if(response.data.status == "1"){
                _this.text = _this.text === 'List' ? 'Menu' : 'List';
                _this.in_list = _this.in_list.concat(response.data.data);
                _this.total_count = response.data.total_count;
                _this.search_total_count = response.data.search_total_count;
                _this.$refs.lm.loadedAll = _this.search_total_count > _this.in_list.length;
                console.error("insert ok-------" + _this.$refs.lm.loadedAll);
                Toast.success('读取更多完成！');
              }
            })
            .catch(function (error) {
              this.loading = false;
              console.log(error);
            });
        }
      },
      submit_search () {
        let _this = this;
        _this.openSearchDialog = false;
        let loading = _this.$loading();
        this.$progress.start();

        Object.assign(_this.searchMap, _this.new_searchMap);
        let parms = {};
        Object.assign(parms, _this.searchMap, {begin: 0});
        console.log("select.mvc response = "+JSON.stringify(parms));
        function init() {
          var p = new Promise(function (resolve, reject) {
            axios.post('/stock/stock/group_select.mvc',Qs.stringify(parms))
              .then(function (response) {
                // console.log("select.mvc response = "+JSON.stringify(response));
                if (response.data.status == "0") {
                  Toast.error('没有数据！');
                }
                if (response.data.status == "2") {
                  Toast.error('查询异常！');
                }
                if (response.data.status == "3") {
                  Dialog.alert({
                    title: '请重新登录',
                    message: ''
                  }).then(() => {
                    _this.$router.replace("/Login");
                  });
                }
                if (response.data.status == "1") {
                  _this.in_list = response.data.data;
                  _this.total_count = response.data.total_count;
                  _this.search_total_count = response.data.search_total_count;
                  _this.$refs.lm.loadedAll = _this.search_total_count > _this.in_list.length;
                  Toast.success('OK！');
                }
                resolve();
              })
              .catch(function (error) {
                console.log(error);
              });
          });
          return p;
        }
        Promise
          .all([
            init()
          ])
          .then(function (results) {
            _this.$progress.done();
            loading.close();
          });
      },
      clear () {
        this.$refs.form.clear();
        this.form = {
          in_stock_type: '',
          in_stock_model:'',
          in_stock_production_date:'',
          in_stock_quantity:'',
          in_stock_date:'',
          in_stock_from:'',
          in_stock_unit_price:'',
          in_stock_total_price:''
        };
      }
    }
  };
</script>

<style scoped>

  .div1{
    display: flex;
    min-height: 100vh;
    flex-direction: column;
  }

  .mu-container{
    min-width:250px;
    width:300px;
  }

  .demo-loadmore-wrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .demo-loadmore-content {
    width: 100%;
    flex: 1;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .s1{
    font-size : 12px;
    font-weight: bolder;
  }
  .s_key{
    font-size : 8px;
    color: rgba(0, 0, 0, .5)
  }
  .table1 {
    border-collapse:collapse; /* 关键属性：合并表格内外边框(其实表格边框有2px，外面1px，里面还有1px哦) */
    border:solid #ddd; /* 设置边框属性；样式(solid=实线)、颜色(#999=灰) */
    border-width:1px 0 0 1px; /* 设置边框状粗细：上 右 下 左 = 对应：1px 0 0 1px */
    font-size: 8px;
    font-weight: normal;
  }
  .table1 th{
    background-color: #fafafa;
    font-weight: normal;
  }
  .table1 th,table td {border:solid #ddd;border-width:0 1px 1px 0;padding:1px;}
  .table1 tfoot td {text-align:center;}

  .table1 .intd{
    background-color: rgba(0, 200, 0, .1);
  }
  .table1 .outtd{
    background-color: rgba(200, 0, 0, .1);
  }
</style>



// WEBPACK FOOTER //
// src/components/select_stock/S_stock.vue